import * as ReactUI from 'react-bootstrap';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import * as Icon from '../../data/photoUrls';
import { appWrapper } from '../../hoc';
import Resume from './resume/Resume';

function Intro() {
  return (
    <ReactUI.Row id="main-row">
      <div className="intro-menu">
        <div className="intro-container">
          <ReactUI.Col md={9} lg={9} className="homeCol">
            <AnimationOnScroll
              animatePreScroll={false}
              className="animate__fadeInLeft"
            >
              <div className="intro">
                <div>
                  <p className="paragraph1">
                    Hi my name is <strong>Ejiroghene</strong>
                  </p>
                  <p className="paragraph">
                    I am an independent Fullstack Web Developer from Essen,
                    Germany 🇩🇪. I design and implement web applications using
                    Node.js, MariaDB, and Git, as well as other technologies
                    such as React, Next.js, GraphQL, and Docker. I work with a
                    team of developers and engineers to deliver high-quality
                    products that meet the needs and expectations of our clients
                    and users. Logical and results-driven Software Developer
                    dedicated to building and optimizing user-focused websites
                    for customers with various business objectives. Judicious
                    and creative when crafting effective websites, apps and
                    platforms to propel competitive advantage and revenue
                    growth. Technically proficient and analytical problem solver
                    with calm and focused demeanor.
                  </p>
                </div>

                <Resume />
              </div>
            </AnimationOnScroll>
          </ReactUI.Col>
          <ReactUI.Col md={3} lg={3} className="homeCol">
            <AnimationOnScroll className="animate__fadeInRightBig">
              <ReactUI.Image
                roundedCircle
                src={Icon.myGitHubIcon}
                alt=""
                width="100%"
              />
            </AnimationOnScroll>
          </ReactUI.Col>
        </div>
      </div>
    </ReactUI.Row>
  );
}

export default appWrapper(Intro, 'home');
